// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__cvZS5","cardMargin":"card_cardMargin__N5E23"};